import React from 'react';
import { PropTypes } from 'prop-types';

import PreviewStudy from '../../../../../core/components/preview-study-button';
import InstructionsSection from '../instructions-section';
import Section from '../section';

import {
  FieldName,
  Grid,
  PreviewStudyContainer,
} from '../../styles';

const ProjectTreeTestSummary = (props) => {
  const {
    baseUrl,
    history,
    values,
    onPreviewStudy,
    smallColumn,
    previewButtonClicked,
  } = props;

  return (
    <>
      <InstructionsSection
        baseUrl={baseUrl}
        history={history}
        values={values}
        smallColumn={smallColumn}
      />
      <Section
        title="Tree & Tasks"
        hasEdit={!!baseUrl}
        edit={() => history.push({ pathname: `${baseUrl}/tree-test`, state: null })}
      >
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column width={16}>
              <PreviewStudyContainer spaceBetween>
                <FieldName>Click “Preview My Study” to view your tree & tasks</FieldName>
                {!!onPreviewStudy && (
                  <PreviewStudy
                    onPreviewStudy={onPreviewStudy}
                    noMargin
                    loading={previewButtonClicked}
                  />
                )}
              </PreviewStudyContainer>
            </Grid.Column>
          </Grid.Row>
        </Grid>

      </Section>

    </>
  );
};

ProjectTreeTestSummary.propTypes = {
  values: PropTypes.shape({
    instructionsContent: PropTypes.string,
    instructionsTitle: PropTypes.string,
    thankYouContent: PropTypes.string,
    thankYouTitle: PropTypes.string,
    tooltipDescription: PropTypes.string,
    welcomeContent: PropTypes.string,
    welcomeTitle: PropTypes.string,
    sortType: PropTypes.string,
    cardSortItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        description: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    cardSortCategories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  baseUrl: PropTypes.string,
  onPreviewStudy: PropTypes.func,
  previewButtonClicked: PropTypes.bool,
  smallColumn: PropTypes.func,
};

ProjectTreeTestSummary.defaultProps = {
  baseUrl: undefined,
  onPreviewStudy: undefined,
  history: {},
  smallColumn: false,
  previewButtonClicked: false,
};

export default ProjectTreeTestSummary;
